<span class="badge" [ngStyle]="{'color': label.textColor, 'background-color': label.backgroundColor}">{{label.name}}<span (click)="remove()" *ngIf="isEditable">&times;</span></span>
